// @flow

import * as React from 'react';
import { ErrorBoundary } from '@ta/common.error-handling';
import shouldSectionUpdate from './sectionUpdater';

type Props = {|
  section: any,
  children: () => React.Node,
|};

export default class FeedSection extends React.Component<Props> {
  shouldComponentUpdate(prevProps: Props) {
    return shouldSectionUpdate(prevProps.section, this.props.section);
  }

  render() {
    const reason =
      this.props.section.items &&
      this.props.section.items[0] &&
      this.props.section.items[0].reasonFor;
    // TODO: move creation of feed sections into this class. Need to untangle
    // existing mess that is getInnerObject from HomeMixerFeed and ActivityObjects
    return (
      <ErrorBoundary>
        <div data-feed-reason={reason}>{this.props.children()}</div>
      </ErrorBoundary>
    );
  }
}
